<template>
  <div class="space-y-3">
    <slot />
  </div>
</template>
  
<script>
export default {
  name: 'BaseAccordion',
};
</script>
  